export const environment = {
  production: false,
  razorpayKey: 'rzp_test_S8zVFIrjVuV97p',
  apiUrl: 'https://dev.ruralx.in/api',
  imageBaseUrl: 'https://dev.ruralx.in/api/',
  getUserDetailsApiURL: 'https://dev.ruralx.in/api/getUserLoginDetails.php',
  searchApiUrl: 'https://dev.ruralx.in/api/search_product.php',
  voiceSearchApiUrl: 'https://dev.ruralx.in/api/voice_search_product.php',
  uploadDataApiUrl: 'https://dev.ruralx.in/api/uploadAdminData.php',
  insertUserDetailsApiUrl: 'https://dev.ruralx.in/api/insertUserDetailsData.php',
  getProductListDetailsApiUrl: 'https://dev.ruralx.in/api/getProductDetails.php',
  getProductNotifyApiUrl: 'https://dev.ruralx.in/api/getProductNotification.php',
  insertshippingAddressApiUrl: 'https://dev.ruralx.in/api/insertShippingAddress.php',
  getShippingAddressApiUrl: 'https://dev.ruralx.in/api/getShippingAddress.php',
  updateShippingAddressApiUrl: 'https://dev.ruralx.in/api/updateShippingaddress.php',
  deleteShippingAddressApiUrl: 'https://dev.ruralx.in/api/deleteShippingAddress.php',
  getCategoryListApiUrl: 'https://dev.ruralx.in/api/get_all_category.php',
  getMainCategoryApiUrl: 'https://dev.ruralx.in/api/mainCategorySearchData.php',
  placeOrderApiUrl: 'https://dev.ruralx.in/api/place_order.php',
  getOrderListApiUrl: 'https://dev.ruralx.in/api/getOrders.php',
  getOrderByIdApiUrl: 'https://dev.ruralx.in/api/get_order_by_id.php',
  upadateStatusApiUrl: 'https://dev.ruralx.in/api/update_order_status.php',
  submitReviewApiUrl: 'https://dev.ruralx.in/api/submit-review.php',
  getReviewApiUrl: 'https://dev.ruralx.in/api/get-review.php',
  submitReviewHelpfulApiUrl: 'https://dev.ruralx.in/api/review-helpful.php',
  getReviewSummaryApiUrl: 'https://dev.ruralx.in/api/get-review-summary.php',
  getReturnOrderApiUrl: 'https://dev.ruralx.in/api/create-return.php',
  addToCartApiUrl: 'https://dev.ruralx.in/api/addToCart.php',
  getCartApiUrl: 'https://dev.ruralx.in/api/getCart.php',
  updateCartQtyApiUrl: 'https://dev.ruralx.in/api/updateCartQuantity.php',
  getProductByIdApiUrl: 'https://dev.ruralx.in/api/getProductById.php',
  forgotPasswordSendOtpApiUrl: 'https://dev.ruralx.in/api/forgot-password-send-otp.php',
  verifyForgotOtpApiUrl: 'https://dev.ruralx.in/api/verify-forgot-otp.php',
  resetPasswordApiUrl: 'https://dev.ruralx.in/api/reset-password.php',
  deleteAccountApiUrl: 'https://dev.ruralx.in/api/delete-account.php',
  checkPincodeApiUrl: 'https://dev.ruralx.in/api/check-pincode.php',
  dashboardProductApiUrl: 'https://dev.ruralx.in/api/dashboard_products.php',
};

